class Typerequest {
  public id: number;
  public typerequest: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.typerequest = name;
  }
}

export default Typerequest;
